import React from "react"

import {ProviderEdit} from "components/backoffice/Storage/Provider/Edit/ProviderEdit"
import {BackofficePage, BackofficePanel} from "components/backoffice/Layout/BackofficePage"

export const ProviderAddRoute = (props: any) => {

  return <BackofficePage eyebrow="Infrastructure" title="Nouveau provider" description="Connectez un espace de stockage source ou média à Zipflix." icon="fa-database">
    <BackofficePanel title="Configuration" description="Les paramètres dépendent du type de stockage choisi." icon="fa-sliders-h">
      <ProviderEdit open />
    </BackofficePanel>
  </BackofficePage>
}
